module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/2-6c0b3003e9ccd1be501327e30423d723.jpg";